/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* POST API REQUESTS
   ========================================================================== */

import { requestWithJwt, requestWithoutJwt } from '../request'

import { AxiosResponse } from 'axios'
// import { DataListCourse, ListCourseParams } from './post.interface'

export const login = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithoutJwt.post<any>('/auth/login', { data: payload }, { withCredentials: true })
}

export const register = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithoutJwt.post<any>('/auth/register', { data: payload }, { withCredentials: true })
}

export const refresh = async (): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>('/auth/refresh', {}, { withCredentials: true })
}

export const logout = async (): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>('/auth/logout', {}, { withCredentials: true })
}

export const sendOTP = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithoutJwt.post<any>('/auth/sendOTP', { data: payload }, { withCredentials: true })
}

export const verifyOTP = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithoutJwt.post<any>('/auth/verifyOTP', { data: payload }, { withCredentials: true })
}

export const resetPassword = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithoutJwt.post<any>('/auth/resetPassword', { data: payload }, { withCredentials: true })
}

// trang thông tin giáo xứ
export const getParishInfo = async (parishId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>(`/parish/${parishId}`, { withCredentials: true })
}
export const updateParishInfo = async (parishId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.put<any>(`/parish/${parishId}`, { data: payload }, { withCredentials: true })
}

// trang danh sách giáo họ
export const getSubParishes = async (): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>('/sub-parish', { withCredentials: true })
}
export const createSubParish = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>('/sub-parish', { data: payload }, { withCredentials: true })
}
export const updateSubParish = async (subParishId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.put<any>(`/sub-parish/${subParishId}`, { data: payload }, { withCredentials: true })
}
export const deleteSubParish = async (subParishId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.delete<any>(`/sub-parish/${subParishId}`, { withCredentials: true })
}

// trang danh sách linh mục
export const getPriest = async (): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>('/priest', { withCredentials: true })
}

export const createPriest = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>('/priest', { data: payload }, { withCredentials: true })
}

export const updatePriest = async (priestId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.put<any>(`/priest/${priestId}`, { data: payload }, { withCredentials: true })
}

export const deletePriest = async (priestId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.delete<any>(`/priest/${priestId}`, { withCredentials: true })
}

// trang danh sách hội đoàn
export const getHoiDoan = async (): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>('/hoidoan', { withCredentials: true })
}

// ============================================================================
// PARISHIONER API - TÁCH THEO TỪNG TAB
// ============================================================================

// 1. API danh sách giáo dân (chỉ thông tin cơ bản)
export const getParishioner = async (): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>('/parishioner', { withCredentials: true })
}

// 2. API chi tiết theo từng tab
export const getParishionerPersonal = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>(`/parishioner/${parishionerId}/canhan`, { withCredentials: true })
}

export const getParishionerAssociations = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>(`/parishioner/${parishionerId}/hoidoan`, { withCredentials: true })
}

export const getParishionerMarriages = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>(`/parishioner/${parishionerId}/honphoi`, { withCredentials: true })
}

export const getParishionerVocation = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>(`/parishioner/${parishionerId}/tanhien`, { withCredentials: true })
}

export const getParishionerCatechism = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>(`/parishioner/${parishionerId}/lophoc`, { withCredentials: true })
}

// 3. API cập nhật theo từng tab
export const updateParishionerPersonal = async (parishionerId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.patch<any>(`/parishioner/${parishionerId}/canhan`, { data: payload }, { withCredentials: true })
}

export const updateParishionerAssociation = async (parishionerId: number, associationId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.patch<any>(`/parishioner/${parishionerId}/hoidoan/${associationId}`, { data: payload }, { withCredentials: true })
}

export const updateParishionerMarriage = async (parishionerId: number, marriageId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.patch<any>(`/parishioner/${parishionerId}/honphoi/${marriageId}`, { data: payload }, { withCredentials: true })
}

export const updateParishionerVocation = async (parishionerId: number, vocationId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.patch<any>(`/parishioner/${parishionerId}/tanhien/${vocationId}`, { data: payload }, { withCredentials: true })
}

// 4. API thêm mới theo từng tab
export const createParishioner = async (payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>('/parishioner', { data: payload }, { withCredentials: true })
}

export const addParishionerAssociation = async (parishionerId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>(`/parishioner/${parishionerId}/hoidoan`, { data: payload }, { withCredentials: true })
}

export const addParishionerMarriage = async (parishionerId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>(`/parishioner/${parishionerId}/honphoi`, { data: payload }, { withCredentials: true })
}

export const addParishionerVocation = async (parishionerId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.post<any>(`/parishioner/${parishionerId}/tanhien`, { data: payload }, { withCredentials: true })
}

// 5. API xóa theo từng tab
export const deleteParishioner = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.delete<any>(`/parishioner/${parishionerId}`, { withCredentials: true })
}

export const deleteParishionerAssociation = async (parishionerId: number, associationId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.delete<any>(`/parishioner/${parishionerId}/hoidoan/${associationId}`, { withCredentials: true })
}

export const deleteParishionerMarriage = async (parishionerId: number, marriageId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.delete<any>(`/parishioner/${parishionerId}/honphoi/${marriageId}`, { withCredentials: true })
}

export const deleteParishionerVocation = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.delete<any>(`/parishioner/${parishionerId}/tanhien`, { withCredentials: true })
}
// ============================================================================
// API CŨ - GIỮ LẠI ĐỂ TƯƠNG THÍCH NGƯỢC
// ============================================================================
export const getParishionerById = async (parishionerId: number): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.get<any>(`/parishioner/${parishionerId}`, { withCredentials: true })
}

export const updateParishioner = async (parishionerId: number, payload: any): Promise<AxiosResponse<any>> => {
  return await requestWithJwt.put<any>(`/parishioner/${parishionerId}`, { data: payload }, { withCredentials: true })
}
